import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserClaims {
  given_name?: string;
  family_name?: string;
  email?: string;
  preferred_username?: string;
  oid?: string;
  [key: string]: any;
}

interface AuthState {
  claims: UserClaims;
}

const initialState: AuthState = {
  claims: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserClaims(state, action: PayloadAction<UserClaims>) {
      state.claims = action.payload;
    },
    clearUserClaims(state) {
      state.claims = {};
    },
  },
});

export const { setUserClaims, clearUserClaims } = authSlice.actions;
export default authSlice.reducer;
